module.exports = __webpack_public_path__ + "static/media/r228.fce93791.jpg";